import { z } from 'zod'

import { GetTimeSchema } from './time.ts'

export const GetCallbackSchema = z.object({
  date: z.coerce.date(),
  id: z.number(),
  inquiry_load_id: z.number(),
  status: z.string(),
  time: GetTimeSchema,
  user_id: z.number(),
})
